import { useEffect, useState } from "react";

const KEY = "billCounter";
const EVENT_NAME = "billCounterChanged";

// eslint-disable-next-line import/prefer-default-export
export const useCurrentCounter = (): {
  currentCounter: string | null;
  setCurrentCounter: (value: string | null) => void;
} => {
  const [currentCounter, setCurrentCounter] = useState<string | null>(
    () => localStorage.getItem(KEY) || null
  );

  useEffect(() => {
    if (currentCounter) {
      localStorage.setItem(KEY, currentCounter);
    } else {
      localStorage.removeItem(KEY);
    }

    // notify same-tab listeners
    window.dispatchEvent(new Event(EVENT_NAME));
  }, [currentCounter]);

  useEffect(() => {
    const sync = () => {
      setCurrentCounter(localStorage.getItem(KEY) || null);
    };

    // for same-tab sync
    window.addEventListener(EVENT_NAME, sync);

    // for cross-tab sync
    window.addEventListener("storage", (e: StorageEvent) => {
      if (e.key === KEY) {
        sync();
      }
    });

    return () => {
      window.removeEventListener(EVENT_NAME, sync);
      window.removeEventListener("storage", sync);
    };
  }, []);

  return { currentCounter, setCurrentCounter };
};
